export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9119.0e0273d9.jpg";